import React, { useEffect, useState } from 'react'
import qs from 'qs'

import { useTranslation } from 'react-i18next'
import { useMediaQuery } from 'react-responsive'
import { useSelector } from 'react-redux'
import { useProducts, useUserSubscriptions } from '../hooks'
import { useLocation } from 'react-router-dom'
import { useSubscriptionActions } from '../actions'
import { API__PAYMENTS } from '../../../api'
import Loader from '../../../components/Loader'
import { PriceSwitcher } from '../../../components/PriceTable'
import IconPending from '../../../svg/iconPending.svg'
import { isPayload } from '../utils'
import { SubscriptionBanner } from './SubscripitonBanner'
import { SubscriptionTable } from './SubscriptionTable'
import { BILLING_CYCLE, BILLING_PERIOD, ORDER_STATUSES } from '../constants'

export const SubscriptionTab = ({ className = '' }) => {
    const isMobile = useMediaQuery({ query: '(max-width: 1199px)' })
    const { user_subscription: userSubscription } = useSelector(state => state)
    const {
        user: { id: userId },
    } = useSelector(state => state)
    const products = useProducts(userId)
    const { t } = useTranslation()
    const location = useLocation()
    const usePayload = isPayload(location)

    const [priceType, setPriceType] = useState(() => {
        const subscriptionCycleType =
            userSubscription.product.billingCycleValue === BILLING_CYCLE.month
                ? BILLING_PERIOD.month
                : BILLING_PERIOD.annual
        return usePayload ? location.state.payload.priceType : subscriptionCycleType
    })
    const [isPending, setIsPending] = useState(false)
    const [actionModal, productActions] = useSubscriptionActions(priceType, t)
    const userSubscriptions = useUserSubscriptions()

    useEffect(() => {
        let id
        const { order_guid } = qs.parse(location.search, { ignoreQueryPrefix: true })

        const checkOrder = async () => {
            const order = await API__PAYMENTS.GET_ORDER({ guid: order_guid })

            if (ORDER_STATUSES.includes(order.orderStatus)) {
                setIsPending(false)

                clearInterval(id)
            } else {
                setIsPending(true)
            }
        }

        if (order_guid) {
            API__PAYMENTS.CREATE_ORDER({ guid: order_guid })
            id = setInterval(checkOrder, 5 * 1000)
            checkOrder()
            setTimeout(() => clearInterval(id), 5 * 1000 * 60)
        }
    }, [location])

    useEffect(() => {
        if (usePayload && productActions) {
            const { priceName } = location.state.payload
            const productAction = productActions[priceName]

            productAction.type === 'upgrade' && productAction.action()

            delete location.state
        }
    }, [usePayload, location, productActions])

    if (!products || !productActions || !userSubscriptions) {
        return <Loader />
    }

    return (
        <>
            {actionModal}
            <div className={`subscriptions ${className}`}>
                {isPending ? (
                    <div className="subscriptions__pending">
                        <img className="payment" src={IconPending} alt="" />
                        <span className="pending-text">{t('_common.pending')}...</span>
                        <h2>
                            {t(
                                'Sometimes activating a tariff can take several minutes. Once the payment has passed, you will receive a confirmation email.',
                            )}
                        </h2>
                    </div>
                ) : (
                    <SubscriptionBanner products={products} />
                )}
                <h1>{t('_pages._billing_and_payments.compare_your_plan')}</h1>
                <PriceSwitcher
                    defaultChecked={priceType}
                    className={'subscriptions__switcher'}
                    onSwitch={setPriceType}
                />
                <SubscriptionTable
                    products={products}
                    productActions={productActions}
                    userSubscription={userSubscription}
                    userSubscriptions={userSubscriptions}
                    priceType={priceType}
                    isMobile={isMobile}
                />
            </div>
        </>
    )
}
